import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RestartAltIcon from '@mui/icons-material/RestartAlt';

interface EmptyWatermarkProps {
  onAddPanel: () => void;
  onResetLayout: () => void;
}

export const EmptyWatermark: React.FC<EmptyWatermarkProps> = ({ onAddPanel, onResetLayout }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        flexDirection: 'column',
        gap: 2,
        color: 'text.secondary',
      }}
    >
      <Typography variant="h6" color="text.secondary">
        No panels open
      </Typography>
      <Typography variant="body2" color="text.disabled">
        Add a panel to get started
      </Typography>
      <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={onAddPanel}
        >
          Add Panel
        </Button>
        <Button
          variant="outlined"
          startIcon={<RestartAltIcon />}
          onClick={onResetLayout}
        >
          Reset Layout
        </Button>
      </Box>
      <Typography variant="caption" color="text.disabled" sx={{ mt: 2 }}>
        or press Ctrl+K to add panels
      </Typography>
    </Box>
  );
};
